import BillingIcon from '@atlaskit/icon/glyph/billing';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import PeopleGroupIcon from '@atlaskit/icon/glyph/people-group';
import PersonIcon from '@atlaskit/icon/glyph/person';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import SettingsIcon from '@atlaskit/icon/glyph/settings';
import { defineMessages } from 'react-intl';

import { Link } from './index';

const messages = defineMessages({
  admin: {
    defaultMessage: 'Administration',
    description: 'Link to the administration portal or site admin',
    id: 'uchi.admin',
  },
  atlassianCommunity: {
    defaultMessage: 'Atlassian Community',
    description: 'Link to Atlassian Community portal',
    id: 'uchi.atlassianCommunity',
  },
  atlassianDocumentation: {
    defaultMessage: 'Atlassian Documentation',
    description: 'Link to Atlassian Documentation portal',
    id: 'uchi.atlassianDocumentation',
  },
  atlassianLicensing: {
    defaultMessage: 'Manage product licenses',
    description: 'Link to Atlassian Licensing portal',
    id: 'uchi.atlassianLicensing',
  },
  atlassianProfile: {
    defaultMessage: 'Manage profile',
    description: 'Link to manage profile',
    id: 'uchi.atlassianProfile',
  },
  atlassianSupport: {
    defaultMessage: 'Atlassian Support',
    description: 'Link to Atlassian Support portal',
    id: 'uchi.atlassianSupport',
  },
});

const links: Link[] = [
  {
    icon: PersonIcon,
    message: messages.atlassianProfile,
    name: 'Manage profile',
    url: 'https://id.atlassian.com/manage-profile',
  },
  {
    icon: QuestionCircleIcon,
    message: messages.atlassianSupport,
    name: 'Atlassian Support',
    url: 'https://support.atlassian.com/',
  },
  {
    icon: PeopleGroupIcon,
    message: messages.atlassianCommunity,
    name: 'Atlassian Community',
    url: 'https://community.atlassian.com/',
  },
  {
    icon: BillingIcon,
    message: messages.atlassianLicensing,
    name: 'Manage product licenses',
    url: 'https://my.atlassian.com/',
  },
  {
    icon: DocumentsIcon,
    message: messages.atlassianDocumentation,
    name: 'Atlassian Documentation',
    url: 'https://confluence.atlassian.com',
  },
];

export const adminLink: Link = {
  icon: SettingsIcon,
  message: messages.admin,
  name: 'Administration',
  url: 'https://admin.atlassian.com/',
};

export const getHelpfulLinks = (withAdmin?: boolean): Link[] => {
  if (withAdmin && !links.includes(adminLink)) {
    links.splice(1, 0, adminLink);
  }

  return links;
};

export const getSiteAdminLink = (siteUrl: string): Link => ({
  icon: SettingsIcon,
  message: messages.admin,
  name: 'Administration',
  url: `${siteUrl}/admin`,
});
